import { render } from "./OrganisationGoodiesAdmin.vue?vue&type=template&id=6c76989c"
import script from "./OrganisationGoodiesAdmin.vue?vue&type=script&lang=js"
export * from "./OrganisationGoodiesAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__